import { extend } from 'flarum/extend';
import UserCard from 'flarum/components/UserCard';
import UserControls from 'flarum/utils/UserControls';
import Button from 'flarum/components/Button';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import UserPointsModal from './components/UserPointsModal';
import Model from 'flarum/Model';
import User from 'flarum/models/User';
import './widget';
import UserPointsHistoryPage from './components/UserPointsHistoryPage';
import PointsLeaderboardPage from './components/PointsLeaderboardPage';

app.initializers.add('tf-points', () => {
  // 注册积分历史页面路由
  app.routes.userPointsHistory = {path: '/u/:username/points-history', component: UserPointsHistoryPage};
  // 注册排行榜页面路由
  app.routes.pointsLeaderboard = {
    path: '/points-leaderboard',
    component: PointsLeaderboardPage
  };
  User.prototype.canEditPoints = Model.attribute('canEditPoints');


  extend(UserCard.prototype, 'infoItems', function (items) {
    const pointsName = app.forum.attribute('tf-points.pointsname') || '[points]';
    const points = this.attrs.user.data.attributes.points || 0;

    // 直接显示积分，不判断noshowzero
    const displayText = pointsName.includes('[points]') 
      ? pointsName.replace('[points]', points)
      : `${pointsName}: ${points}`;
    
    items.add('points',
      <span>{displayText}</span>
    );
    
    // 添加积分明细链接
    if (this.attrs.user.data.attributes.points !== undefined) {
      const username = this.attrs.user.data.attributes.username;
      if (username) {
        items.add('points-history',
          <a href={app.route('userPointsHistory', {username: username})} className="UserCard-pointsHistory">
            {app.translator.trans('tf-points.forum.user_card.points_history')}
          </a>
        );
      }
    }
  });

  extend(UserControls, 'moderationControls', (items, user) => {
    if (user.canEditPoints()) {
      items.add('points', Button.component({
        icon: 'fa-light fa-star',
        onclick: () => app.modal.show(UserPointsModal, {user})
      }, app.translator.trans('tf-points.forum.user_controls.points_button')));
    }
  });

  // 扩展 FoF Share Social 的分享功能，添加积分奖励
  // 只在 FofShareSocialModal 内的分享按钮点击后调用积分接口
  extend(DiscussionPage.prototype, 'oncreate', function() {
    const self = this;
    
    // 在组件初始化后，监听 FofShareSocialModal 内的分享按钮点击
    this.sharePointsHandler = function(e) {
      // 检查点击的元素是否在 FofShareSocialModal 内
      const $target = $(e.target).closest('.Button');
      const $modal = $target.closest('.FofShareSocialModal');
      // 只处理 FofShareSocialModal 内的按钮
      if ($modal.length === 0) {
        return;
      }
      
      // 排除复制按钮（复制按钮通常有 fa-copy 图标或 Button--primary 类）
      if ($target.find('.fa-copy').length > 0 || 
          ($target.hasClass('Button--primary') && $target.closest('.ShareUrl').length > 0)) {
        return;
      }
      
      // 检查是否是分享按钮（分享按钮通常有 Share-- 类名）
      const buttonClass = $target.attr('class') || '';
      const isShareButton = buttonClass.includes('Share--') || 
                           $target.find('[class*="Share--"]').length > 0 ||
                           $target.find('.fab, .fa-facebook, .fa-twitter, .fa-linkedin, .fa-reddit, .fa-whatsapp, .fa-telegram, .fa-vk, .fa-qq, .fa-share-square').length > 0;
      if (!isShareButton) {
        return;
      }
      

     
      
      // 获取当前讨论和首帖ID
      const discussion = self.discussion;
      if (!discussion) {
        return;
      }
  
      
      const postId = discussion.data.id;
      
      // 延迟执行，确保分享操作已完成
      // 注意：由于 FoF Share Social 使用 window.open() 打开分享窗口，
      // 我们无法直接检测分享是否成功，但可以在用户点击分享按钮后调用积分接口
      // 分享接口会在后端处理积分逻辑
      setTimeout(() => {
        // 调用分享接口（POST 方法，触发积分）
        app.request({
          method: 'GET',
          url: app.forum.attribute('apiUrl') + '/share/discussions/' + postId
        }).then(() => {
          // 分享接口调用成功，积分会在后端自动处理
        }).catch(err => {
          // 分享接口调用失败，静默处理（避免影响分享功能）
          console.error('分享积分接口调用失败:', err);
        }).finally(() => {
          // 重置标记，允许下次分享
          setTimeout(() => {
            $target.removeData('points-processed');
          }, 2000);
        });
      }, 500); // 延迟 500ms，确保分享窗口已经打开
    };
    
    // 只监听 FofShareSocialModal 内的按钮点击
    $(document).on('click', '.FofShareSocialModal .Button', this.sharePointsHandler);
  });
  
  extend(DiscussionPage.prototype, 'onremove', function() {
    // 组件移除时，解绑事件监听器
    if (this.sharePointsHandler) {
      $(document).off('click', '.FofShareSocialModal .Button', this.sharePointsHandler);
    }
  });

});